import { useEffect, useState } from 'react';

import { useWindowSize } from '@app/hooks';

export const useContentWidth = () => {
  const { innerWidth } = useWindowSize();
  const [contentWidth, setContentWidth] = useState<number>(0);

  useEffect(() => {
    const antLayoutContent = document.querySelector('.ant-layout-content');

    if (antLayoutContent) {
      const _contentWidth = antLayoutContent.getBoundingClientRect().width;
      const contentMarginsAndPaddings = (16 + 24) * 2;

      setContentWidth(_contentWidth - contentMarginsAndPaddings);
    } else {
      setContentWidth(0);
    }
  }, [innerWidth]);

  return {
    contentWidth,
  };
};
